// MetricsPage 와 그 하위 패널이 같이 쓰는 숫자 표기. (MetricsPage 에서 동작 그대로 옮김)

export const formatMetricNumber = (value?: number | null) => {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '0';
  }
  return value.toLocaleString('ko-KR', { maximumFractionDigits: 2 });
};

export const formatMetricPercent = (value: number | null) => (value === null ? '비교 불가' : `${formatMetricNumber(value)}%`);
